module.exports = __webpack_public_path__ + "res/img_more.8026b7b4fe904e3ff02e882430db7934.png";